import { MenuEntry } from '@src/menu-entry';

export default [
    MenuEntry.create()
        .setRoute('category_list')
        .setAdditionalRoutes([
            'category',
        ]),

    MenuEntry.create()
        .setRoute('facet_group_list')
        .setAdditionalRoutes([
            'facet_group',
        ]),

    MenuEntry.create()
        .setRoute('facet_list')
        .setAdditionalRoutes([
            'facet',
        ]),

];
